// -----------------------------------------------------------------------------
// Classifica online — identità anonima (token + nickname permanente).
// Il token segreto vive SOLO qui, nel localStorage del dispositivo; il server
// ne conserva solo l'hash. Il bestScore ufficiale è sempre quello del server.
// -----------------------------------------------------------------------------

import { getBestScore, setBestScore } from "@/play/storage";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const KEYS = {
  TOKEN: "ft_player_token",
  ID: "ft_player_id",
  NICK: "ft_nickname",
};

function get(k) {
  try {
    return window.localStorage.getItem(k);
  } catch {
    return null;
  }
}

function set(k, v) {
  try {
    window.localStorage.setItem(k, v);
  } catch {
    /* quota/privato: ignora */
  }
}

export function getToken() {
  return get(KEYS.TOKEN);
}

export function getNickname() {
  return get(KEYS.NICK);
}

export function hasProfile() {
  return !!getToken();
}

async function req(path, { method = "GET", body, auth = false } = {}) {
  const headers = { "Content-Type": "application/json" };
  if (auth) {
    const t = getToken();
    if (t) headers["Authorization"] = `Bearer ${t}`;
  }
  const res = await fetch(`${API}${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });
  let data = null;
  try {
    data = await res.json();
  } catch {
    /* risposta senza body JSON */
  }
  if (!res.ok) {
    const msg = data && data.detail ? data.detail : `Errore (${res.status})`;
    const err = new Error(msg);
    err.status = res.status;
    throw err;
  }
  return data;
}

// Crea il giocatore. Il nickname è permanente: nessun endpoint di rinomina.
// Il record personale locale già esistente viene trasferito in classifica (initialBest),
// così l'utente NON deve rifare il record: record personale = punteggio in classifica.
export async function createPlayer(nickname) {
  const initialBest = getBestScore();
  const data = await req("/players", {
    method: "POST",
    body: { nickname, initialBest },
  });
  set(KEYS.TOKEN, data.token);
  set(KEYS.ID, data.playerId);
  set(KEYS.NICK, data.nickname);
  // Mantiene un solo record: allinea il locale al valore ufficiale del server.
  if (typeof data.bestScore === "number") setBestScore(data.bestScore);
  return data;
}

// Apre una sessione di gioco lato server (timestamp autoritativo per anti-cheat).
export async function openSession() {
  const data = await req("/session", { method: "POST", auth: true });
  return data.sessionToken;
}

// Invia il punteggio finale di una sessione (una sola volta per sessione).
export async function submitScore(sessionToken, score) {
  return req("/scores", {
    method: "POST",
    auth: true,
    body: { sessionToken, score },
  });
}

export async function getMe() {
  return req("/players/me", { auth: true });
}

export async function getLeaderboard(limit = 100) {
  return req(`/leaderboard?limit=${limit}`);
}
